import { createFileRoute } from '@tanstack/react-router'
import { GlossaryPage, glossaryHead } from '@/components/glossary-page'

const data = {
  term: 'Incident Management',
  slug: 'incident-management',
  definition: `Incident management is the process of identifying, analyzing, and resolving unplanned disruptions to a service. It covers everything from initial detection through resolution and postmortem analysis.

A typical incident lifecycle has five stages: detection, triage, investigation, resolution, and review. Good incident management means having clear processes for each stage so the team can move quickly under pressure.

Modern incident management emphasizes automation where possible — automatic detection via monitoring, automatic alerting via escalation policies, and automatic status page updates to keep users informed.`,
  whyItMatters: `Without a structured incident management process, teams waste time during outages figuring out who should do what. Every minute spent on coordination instead of fixing the problem extends the downtime.

Teams with mature incident management practices consistently achieve lower MTTR. They also learn more from each incident through postmortems, reducing the likelihood of the same failure happening again.`,
  howUptrackHelps: `Uptrack creates incidents automatically when confirmed downtime is detected. Alerts are sent to the right channels immediately, so your team can start working on the fix without manual triage.

Status pages keep your users informed during incidents, reducing support ticket volume. After resolution, Uptrack provides precise incident timelines for your postmortem reviews.`,
  relatedTerms: [
    { name: 'MTTR', href: '/glossary/mttr' },
    { name: 'Escalation Policy', href: '/glossary/escalation-policy' },
    { name: 'On-Call', href: '/glossary/on-call' },
    { name: 'Status Page', href: '/glossary/status-page' },
  ],
}

export const Route = createFileRoute('/_site/glossary/incident-management')({
  component: () => <GlossaryPage data={data} />,
  head: () => glossaryHead(data),
})
